import { ActionTypes } from '../constants/ActionTypes';
import { AnyAction } from 'redux';
import { IUserInfo } from '../models/IUserInfo';


export function IdentityReducer(state: IUserInfo | null = null, action: AnyAction): IUserInfo | null {
    switch (action.type) {
        case ActionTypes.SET_PROFILE_INFO:
            return SetProfileInfo(action);
    }
    return state;
}

function SetProfileInfo(action: AnyAction): IUserInfo {
    return action.payload as IUserInfo;
}


// WEBPACK FOOTER //
// ./src/reducers/IdentityReducer.tsx